import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from "react";
export var childrenToArray = function childrenToArray(children) {
  var newFirstChildren = [];
  return React.Children.forEach(children, function (child) {
    newFirstChildren.push(child);
  }), newFirstChildren;
};